// Disable max class per file due to form validation classes
/* eslint-disable max-classes-per-file */

import {IsNotEmpty, IsString} from 'class-validator';


export class AashtowareForm {

  @IsString()
  @IsNotEmpty()
  code: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsString()
  @IsNotEmpty()
  specBook: string;

  @IsString()
  @IsNotEmpty()
  description: string;

  @IsString()
  @IsNotEmpty()
  unit: string;

  @IsString()
  @IsNotEmpty()
  unitSystem: string;
 
}
